<template>
  <NewComponentLayout>
    <template #title>
      {{ $t('newcomponent.chart.title') }}
    </template>

    <ComponentChartForm />
  </NewComponentLayout>
</template>
<script setup lang="ts">
import NewComponentLayout from '../../layouts/NewComponentLayout.vue';
import ComponentChartForm from '../../components/form/ComponentChartForm.vue'
</script>